import React from "react";
import { CLIENT_PRIVACY_FIELDS } from "@/lib/client-privacy";

export default function ClientPrivacyControls({ value, onChange }) {
  return (
    <fieldset className="space-y-3" data-testid="client-privacy-controls">
      <legend className="text-sm font-semibold">Hide client information</legend>
      <p className="text-xs" style={{ color: "var(--fb-text-muted)" }}>
        Select details this account must not see, including in reports and exports.
        Staff profile information is not affected.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {CLIENT_PRIVACY_FIELDS.map(({ value: field, label, description }) => (
          <label key={field} className="flex items-start gap-2.5 text-sm cursor-pointer">
            <input type="checkbox" checked={value.includes(field)}
              onChange={() => onChange(value.includes(field)
                ? value.filter((v) => v !== field) : [...value, field])}
              data-testid={`client-privacy-${field}`} className="mt-0.5 rounded" />
            <span>{label}{description && <span className="block text-xs mt-0.5"
              style={{ color: "var(--fb-text-muted)" }}>{description}</span>}</span>
          </label>
        ))}
      </div>
      {value.length > 0 && (
        <p className="text-xs" style={{ color: "var(--fb-text-muted)" }}>
          Private notes and unreviewed requests are also hidden because they may contain these details.
          Client profile editing, imports, audit logs, portal links, and offline client access are unavailable.
          Visits and queue actions remain available according to the account’s role.
        </p>
      )}
    </fieldset>
  );
}
